import { schedulesByLocation } from '../../../mocks/courses';

export default function ScheduleSection() {
  return (
    <section id="schedule" className="py-14 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-5 md:px-12">
        <h2 className="text-[1.6rem] md:text-5xl font-bold text-center mb-10 md:mb-16 leading-tight" style={{ fontFamily: 'Noto Serif KR, serif' }}>
          <span className="text-[#1a2332]">학교별 맞춤형</span><br />
          <span className="text-[#4ecdc4]">시간표</span>
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
          {schedulesByLocation.map((location) => (
            <div key={location.id} className="bg-gradient-to-br from-[#f7f7f5] to-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="flex items-center gap-3 mb-6 md:mb-7">
                <div className="w-12 h-12 md:w-14 md:h-14 bg-gradient-to-br from-[#4ecdc4] to-[#3ab8af] rounded-full flex items-center justify-center">
                  <i className="ri-map-pin-line text-2xl md:text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-[#1a2332]" style={{ fontFamily: 'Noto Serif KR, serif' }}>
                  {location.name}
                </h3>
              </div>

              <div className="space-y-3 md:space-y-4">
                {location.schedules.map((schedule, index) => (
                  <div 
                    key={index}
                    className="bg-white rounded-xl p-4 md:p-5 border-l-4 border-[#4ecdc4] hover:border-[#ff6b6b] transition-colors duration-300 cursor-pointer group"
                  >
                    <div className="flex items-start justify-between gap-3">
                      <div className="flex-1">
                        <h4 className="text-[16px] md:text-xl font-bold text-[#1a2332] mb-2 group-hover:text-[#4ecdc4] transition-colors duration-300">
                          {schedule.school}
                        </h4>
                        <div className="flex items-center gap-2 text-gray-700">
                          <i className="ri-time-line text-[#ff6b6b]"></i>
                          <p className="text-[14px] md:text-base font-medium">
                            {schedule.time}
                          </p>
                        </div>
                      </div>
                      <div className="w-10 h-10 md:w-10 md:h-10 bg-[#4ecdc4]/10 rounded-full flex items-center justify-center group-hover:bg-[#4ecdc4] transition-colors duration-300">
                        <i className="ri-arrow-right-line text-xl text-[#4ecdc4] group-hover:text-white transition-colors duration-300"></i>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-12 bg-gradient-to-r from-[#1a2332] to-[#2a3342] rounded-2xl p-6 md:p-7 text-white text-center">
          <p className="text-[14px] md:text-lg mb-2 md:mb-2 leading-relaxed">
            <i className="ri-information-line text-[#4ecdc4] mr-2"></i>
            내신 기간 <strong>불가피하게 시간표 조정</strong>을 할 수도 있습니다,
          </p>
          <p className="text-[13px] md:text-base text-gray-300">
            상담 시 자세한 시간표를 안내해 드립니다
          </p>
        </div>
      </div>
    </section>
  );
}
